/**
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * @format
 */

import dumpVisualTree from './dumpVisualTree';

export {dumpVisualTree};
